export default __webpack_public_path__ + "static/media/tick-black.ba323578.svg";